import React from 'react';
import style from "./input.module.scss"
import InputMask from "react-input-mask";


const Input = ({label, placeholder, value, setValue, type})=> {
    if (type === 'phone') {
        return (
            <div className={style.block}>
                <div className={style.label}>{label}</div>
                <InputMask
                    mask="+7 (999) 999-99-99"
                    maskChar={null}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                    className={style.input}
                />
            </div>
        )
    }
    return (
        <div className={style.block}>
            <div className={style.label}>{label}</div>
            <input className={style.input} type={type || "text"} value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder}/>
        </div>
    );
};

export default Input;